export default function chosenDirective($timeout) {
    return {
        restrict: 'AE',
        // require: 'ngModel',
        scope: {
            config: '=',
            ngModel: '=',
            listModel: '=',
        },
        link($scope, element, $attrs) {
            // bind
            // view -> model

            const elm = $(element).chosen({ disable_search_threshold: 5 }).change((event, option) => {
                $scope.$apply(() => {
                    $scope.ngModel = option.selected
                })

                console.log(event)
            })

            $scope.$watch('listModel', (newVal) => {
                //  if(!(newVal instanceof Array)) return console.error("list-model 传入错误参数类型");
                //  if(newVal.length > 0 ) {
                //     var elements = element[0].children;
                //  }
                $(element).trigger('chosen:updated')
            })


            // model - > view
            $scope.$watch('ngModel', (newVal) => {
                if (!newVal) return
                $(element).trigger('chosen:updated')
                // //选中业务逻辑
                ;(function () {
                    function setSelected(str) {
                        const elements = element[0].children
                        for (let i = 0; i < elements.length; i++) {
                            if (elements[i].text == str) {
                                //  console.log(elements[i].text);
                                return elements[i].selected = true
                            }
                        }
                    }
                    //  存在决议 设置选中
                    if (newVal.$modelValue && newVal.$modelValue != '[]') {
                        // debugger;
                        newVal.$modelValue = newVal.$modelValue.replace(/[\[\]]| */g, '')
                        const arr = newVal.$modelValue.split(',')
                        for (let n = 0; n < arr.length; n++) {
                            setSelected(arr[n])
                        }
                    }
                }())
            })

            // 是否有设置外部数据集
            // var models;
            // if($attrs.model) {
            //     models = $scope[$attrs.model];
            // } else {
            //     return;
            // }

            // end  选中
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/chosen/chosenDirective.js